import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showConfirmCancelDialog, showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'opportunities', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_POSTPONE',
				icon: 'calendar-end',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'opportunities'),
				action: ({ dispatch, updateRefresh, model, t, userData }) =>
					dispatch(
						showConfirmCancelDialog({
							title: t('DIALOG_TITLE_POSTPONE'),
							onConfirm: () => {
								dispatch(Utils.alertProgressMsg(t));
								Utils.executeStored({
									action: 'st_opportunities_update',
									dispatch,
									data: {
										oppo_uid: model.oppo_uid,
										oppo_user_modified_uid: userData.user_uid,
										oppo_d_to: (Utils.parseDate(model.oppo_d_to) || Utils.today()).add(10, 'day')
									},
									successHandler: () => {
										dispatch(Utils.alertSuccessMsg(t));
										updateRefresh();
									}
								});
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'opportunities'),
				action: ({ model, t }) => {
					const { oppo_title } = model;
					Utils.openLink({
						pathname: '/opportunities/add',
						state: {
							model: { ...model, oppo_title: oppo_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(
						showAddNotesDialog({ model: { note_table: 'opportunities', note_table_uid: model.oppo_uid } })
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: {
								oppo_maac_uid: model.oppo_maac_uid,
								oppo_dems_uid: model.oppo_dems_uid,
								oppo_parent_oppo_uid: model.oppo_uid,
								oppo_cntr_uid: model.oppo_cntr_uid,
								oppo_ords_uid: model.oppo_ords_uid,
								oppo_proj_uid: model.oppo_proj_uid,
								oppo_acti_uid: model.oppo_acti_uid,
								oppo_chro_uid: model.oppo_chro_uid,
								oppo_wore_uid: model.oppo_wore_uid,
								oppo_tick_uid: model.oppo_tick_uid,
								oppo_comp_uid: model.oppo_comp_uid,
								oppo_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: {
								cntr_maac_uid: model.oppo_maac_uid,
								cntr_dems_uid: model.oppo_dems_uid,
								cntr_oppo_uid: model.oppo_uid,
								cntr_parent_cntr_uid: model.oppo_cntr_uid,
								cntr_ords_uid: model.oppo_ords_uid,
								cntr_proj_uid: model.oppo_proj_uid,
								cntr_acti_uid: model.oppo_acti_uid,
								cntr_wore_uid: model.oppo_wore_uid,
								cntr_chro_uid: model.oppo_chro_uid,
								cntr_tick_uid: model.oppo_tick_uid,
								cntr_comp_uid: model.oppo_comp_uid,
								cntr_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: {
								ords_maac_uid: model.oppo_maac_uid,
								ords_dems_uid: model.oppo_dems_uid,
								ords_oppo_uid: model.oppo_uid,
								ords_cntr_uid: model.oppo_cntr_uid,
								ords_parent_ords_uid: model.oppo_ords_uid,
								ords_proj_uid: model.oppo_proj_uid,
								ords_acti_uid: model.oppo_acti_uid,
								ords_wore_uid: model.oppo_wore_uid,
								ords_chro_uid: model.oppo_chro_uid,
								ords_tick_uid: model.oppo_tick_uid,
								ords_comp_uid: model.oppo_comp_uid,
								ords_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: {
								proj_maac_uid: model.oppo_maac_uid,
								proj_dems_uid: model.oppo_dems_uid,
								proj_oppo_uid: model.oppo_uid,
								proj_cntr_uid: model.oppo_cntr_uid,
								proj_ords_uid: model.oppo_ords_uid,
								proj_parent_proj_uid: model.oppo_proj_uid,
								proj_acti_uid: model.oppo_acti_uid,
								proj_wore_uid: model.oppo_wore_uid,
								proj_chro_uid: model.oppo_chro_uid,
								proj_tick_uid: model.oppo_tick_uid,
								proj_comp_uid: model.oppo_comp_uid,
								proj_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_maac_uid: model.oppo_maac_uid,
								acti_dems_uid: model.oppo_dems_uid,
								acti_oppo_uid: model.oppo_uid,
								acti_cntr_uid: model.oppo_cntr_uid,
								acti_ords_uid: model.oppo_ords_uid,
								acti_proj_uid: model.oppo_proj_uid,
								acti_parent_acti_uid: model.oppo_acti_uid,
								acti_wore_uid: model.oppo_wore_uid,
								acti_chro_uid: model.oppo_chro_uid,
								acti_tick_uid: model.oppo_tick_uid,
								acti_comp_uid: model.oppo_comp_uid,
								acti_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_maac_uid: model.oppo_maac_uid,
								chro_dems_uid: model.oppo_dems_uid,
								chro_oppo_uid: model.oppo_uid,
								chro_cntr_uid: model.oppo_cntr_uid,
								chro_ords_uid: model.oppo_ords_uid,
								chro_proj_uid: model.oppo_proj_uid,
								chro_acti_uid: model.oppo_acti_uid,
								chro_wore_uid: model.oppo_wore_uid,
								chro_parent_chro_uid: model.oppo_chro_uid,
								chro_tick_uid: model.oppo_tick_uid,
								chro_comp_uid: model.oppo_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_WORKREPORT',
				icon: 'text-box-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'workreports',
							updateRefresh,
							model: {
								wore_maac_uid: model.oppo_maac_uid,
								wore_dems_uid: model.oppo_dems_uid,
								wore_oppo_uid: model.oppo_uid,
								wore_cntr_uid: model.oppo_cntr_uid,
								wore_ords_uid: model.oppo_ords_uid,
								wore_proj_uid: model.oppo_proj_uid,
								wore_acti_uid: model.oppo_acti_uid,
								wore_parent_wore_uid: model.oppo_wore_uid,
								wore_chro_uid: model.oppo_chro_uid,
								wore_tick_uid: model.oppo_tick_uid,
								wore_comp_uid: model.oppo_comp_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'opportunities'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'opportunities',
							id: model.oppo_uid,
							title: model.oppo_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'opportunities'),
				action: () => Utils.openLink({ pathname: '/opportunities/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'opportunities'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'opportunities'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'opportunities',
							id: model.oppo_uid,
							title: model.oppo_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'opportunities'),
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'contracts',
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: {
								cntr_maac_uid: model.oppo_maac_uid,
								cntr_dems_uid: model.oppo_dems_uid,
								cntr_oppo_uid: model.oppo_uid,
								cntr_parent_cntr_uid: model.oppo_cntr_uid,
								cntr_ords_uid: model.oppo_ords_uid,
								cntr_proj_uid: model.oppo_proj_uid,
								cntr_acti_uid: model.oppo_acti_uid,
								cntr_wore_uid: model.oppo_wore_uid,
								cntr_chro_uid: model.oppo_chro_uid,
								cntr_tick_uid: model.oppo_tick_uid,
								cntr_comp_uid: model.oppo_comp_uid,
								cntr_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				id: 'orders',
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: {
								ords_maac_uid: model.oppo_maac_uid,
								ords_dems_uid: model.oppo_dems_uid,
								ords_oppo_uid: model.oppo_uid,
								ords_cntr_uid: model.oppo_cntr_uid,
								ords_parent_ords_uid: model.oppo_ords_uid,
								ords_proj_uid: model.oppo_proj_uid,
								ords_acti_uid: model.oppo_acti_uid,
								ords_wore_uid: model.oppo_wore_uid,
								ords_chro_uid: model.oppo_chro_uid,
								ords_tick_uid: model.oppo_tick_uid,
								ords_comp_uid: model.oppo_comp_uid,
								ords_peop_uid: model.oppo_peop_uid,
								ords_user_assigned_uid: model.oppo_user_assigned_uid,
								ords_user_assigned_2_uid: model.oppo_user_assigned_2_uid
							}
						})
					)
			},
			{
				id: 'projects',
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: {
								proj_maac_uid: model.oppo_maac_uid,
								proj_dems_uid: model.oppo_dems_uid,
								proj_oppo_uid: model.oppo_uid,
								proj_cntr_uid: model.oppo_cntr_uid,
								proj_ords_uid: model.oppo_ords_uid,
								proj_parent_proj_uid: model.oppo_proj_uid,
								proj_acti_uid: model.oppo_acti_uid,
								proj_wore_uid: model.oppo_wore_uid,
								proj_chro_uid: model.oppo_chro_uid,
								proj_tick_uid: model.oppo_tick_uid,
								proj_comp_uid: model.oppo_comp_uid,
								proj_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				id: 'activities',
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_maac_uid: model.oppo_maac_uid,
								acti_dems_uid: model.oppo_dems_uid,
								acti_oppo_uid: model.oppo_uid,
								acti_cntr_uid: model.oppo_cntr_uid,
								acti_ords_uid: model.oppo_ords_uid,
								acti_proj_uid: model.oppo_proj_uid,
								acti_parent_acti_uid: model.oppo_acti_uid,
								acti_wore_uid: model.oppo_wore_uid,
								acti_chro_uid: model.oppo_chro_uid,
								acti_tick_uid: model.oppo_tick_uid,
								acti_comp_uid: model.oppo_comp_uid,
								acti_peop_uid: model.oppo_peop_uid
							}
						})
					)
			},
			{
				id: 'chronology',
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_maac_uid: model.oppo_maac_uid,
								chro_dems_uid: model.oppo_dems_uid,
								chro_oppo_uid: model.oppo_uid,
								chro_cntr_uid: model.oppo_cntr_uid,
								chro_ords_uid: model.oppo_ords_uid,
								chro_proj_uid: model.oppo_proj_uid,
								chro_acti_uid: model.oppo_acti_uid,
								chro_wore_uid: model.oppo_wore_uid,
								chro_parent_chro_uid: model.oppo_chro_uid,
								chro_tick_uid: model.oppo_tick_uid,
								chro_comp_uid: model.oppo_comp_uid
							}
						})
					)
			},
			{
				id: 'workreports',
				name: 'VIEW_ITEM_BUTTON_NEW_WORKREPORT',
				icon: 'text-box-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('workreports') || authorizer.cannot('create', 'workreports'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'workreports',
							updateRefresh,
							model: {
								wore_maac_uid: model.oppo_maac_uid,
								wore_dems_uid: model.oppo_dems_uid,
								wore_oppo_uid: model.oppo_uid,
								wore_cntr_uid: model.oppo_cntr_uid,
								wore_ords_uid: model.oppo_ords_uid,
								wore_proj_uid: model.oppo_proj_uid,
								wore_acti_uid: model.oppo_acti_uid,
								wore_parent_wore_uid: model.oppo_wore_uid,
								wore_chro_uid: model.oppo_chro_uid,
								wore_tick_uid: model.oppo_tick_uid,
								wore_comp_uid: model.oppo_comp_uid
							}
						})
					)
			}
		]
	}
};

export default buttons;
